import { render, staticRenderFns } from "./RelicList.vue?vue&type=template&id=70c8d5e6"
import script from "./RelicList.vue?vue&type=script&lang=js"
export * from "./RelicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports